// ===========================
// MJ GROUP REAL ESTATE — Property Page
// Formulario · Tour · Mapa · WhatsApp
// (Galería gestionada inline en product.liquid)
// ===========================

// ===== LIMPIAR FILA "ÁREA TERRENO" CUANDO NO APLICA =====
// Funciona 100% en cliente. Detecta apartamentos / áreas residuales (≤5 m²) y borra la fila.
(function () {
  function clean() {
    var tipoEl = document.querySelector('.sidebar-price__type');
    var tipoTxt = tipoEl ? tipoEl.textContent.toLowerCase() : '';
    var sinTerreno = /apart|aparta|penthouse|duplex|d[uú]plex|oficina|local|bodega/.test(tipoTxt);

    document.querySelectorAll('.prop-table tr, .prop-description table tr').forEach(function (row) {
      var label = row.querySelector('td strong, th');
      if (!label) return;
      var labelTxt = (label.textContent || '').trim().toLowerCase();
      // Cubre "área terreno", "Área terreno", "Area terreno"
      if (labelTxt.indexOf('rea terreno') === -1 && labelTxt.indexOf('rea de terreno') === -1) return;
      var cells = row.querySelectorAll('td');
      var valTxt = cells.length > 1 ? cells[cells.length - 1].textContent : '';
      var num = parseInt((valTxt.match(/\d+/) || [0])[0], 10);
      if (sinTerreno || num <= 5) {
        row.parentNode.removeChild(row);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clean);
  } else {
    clean();
  }
})();

// (Galería inicializada inline en product.liquid — ver ese archivo)

// ===== LEER MÁS — CON ANIMACIÓN =====
const readMoreBtn = document.getElementById('readMoreBtn');
const moreText    = document.getElementById('moreText');

if (readMoreBtn && moreText) {
  readMoreBtn.addEventListener('click', () => {
    const isHidden = moreText.style.display === 'none' || moreText.style.display === '';

    if (isHidden) {
      moreText.style.display   = 'block';
      moreText.style.opacity   = '0';
      moreText.style.transform = 'translateY(-10px)';

      requestAnimationFrame(() => {
        moreText.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
        moreText.style.opacity    = '1';
        moreText.style.transform  = '';
      });
    } else {
      moreText.style.transition = 'opacity 0.3s ease';
      moreText.style.opacity    = '0';
      setTimeout(() => {
        moreText.style.display    = 'none';
        moreText.style.transition = '';
      }, 310);
    }

    readMoreBtn.textContent = isHidden ? 'Ver menos ↑' : 'Ver descripción completa ↓';
  });
}

// ===== FORM SUBMIT — FEEDBACK VISUAL =====
function handleFormSubmit() {
  const form    = document.querySelector('.sidebar-form');
  const success = document.getElementById('formSuccess');
  if (!form || !success) return;

  form.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
  form.style.opacity    = '0';
  form.style.transform  = 'scale(0.97)';

  setTimeout(() => {
    form.style.display = 'none';
    success.style.display   = 'flex';
    success.style.opacity   = '0';
    success.style.transform = 'scale(0.96)';

    requestAnimationFrame(() => {
      success.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      success.style.opacity    = '1';
      success.style.transform  = '';
    });
  }, 320);
}

// ===== ACTIVAR TOUR MATTERPORT =====
function activarTour() {
  const input       = document.getElementById('matterportUrl');
  const embed       = document.getElementById('tourEmbed');
  const placeholder = document.getElementById('tourPlaceholder');
  const url         = input.value.trim();

  if (!url) {
    input.style.borderColor = '#E63946';
    input.focus();
    return;
  }

  input.style.borderColor = '';

  let modelId = '';
  const match = url.match(/[?&]m=([^&]+)/);
  if (match) {
    modelId = match[1];
  } else if (!url.includes('matterport.com')) {
    modelId = url;
  }

  const embedUrl = modelId
    ? `https://my.matterport.com/show/?m=${modelId}&play=1&qs=1`
    : url;

  // Fade out placeholder
  placeholder.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
  placeholder.style.opacity    = '0';
  placeholder.style.transform  = 'scale(0.97)';

  setTimeout(() => {
    placeholder.style.display = 'none';

    const iframe = document.createElement('iframe');
    iframe.src   = embedUrl;
    iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;opacity:0;transition:opacity 0.6s ease;';
    iframe.allow         = 'xr-spatial-tracking; gyroscope; accelerometer';
    iframe.allowFullscreen = true;

    embed.style.position = 'relative';
    embed.appendChild(iframe);

    requestAnimationFrame(() => {
      setTimeout(() => { iframe.style.opacity = '1'; }, 50);
    });
  }, 320);
}

// ===== ACTIVAR GOOGLE MAPS =====
function abrirMapa() {
  const input       = document.getElementById('mapAddress');
  const frame       = document.getElementById('mapFrame');
  const iframe      = document.getElementById('googleMapIframe');
  const placeholder = document.querySelector('.map-embed__placeholder');
  const address     = input.value.trim();

  if (!address) {
    input.style.borderColor = '#E63946';
    input.focus();
    return;
  }

  input.style.borderColor = '';

  if (address.includes('maps/embed') || address.includes('maps.google.com/maps')) {
    iframe.src = address;
  } else {
    const encoded = encodeURIComponent(address + ', Colombia');
    iframe.src    = `https://maps.google.com/maps?q=${encoded}&output=embed&z=16`;
  }

  // Fade out placeholder
  placeholder.style.transition = 'opacity 0.3s ease';
  placeholder.style.opacity    = '0';

  setTimeout(() => {
    placeholder.style.display = 'none';

    const mapEmbed = document.getElementById('mapEmbed');
    if (mapEmbed) mapEmbed.style.minHeight = '420px';

    frame.style.display    = 'block';
    frame.style.position   = 'absolute';
    frame.style.inset      = '0';
    frame.style.width      = '100%';
    frame.style.height     = '100%';
    frame.style.opacity    = '0';
    frame.style.transition = 'opacity 0.5s ease';

    requestAnimationFrame(() => {
      setTimeout(() => { frame.style.opacity = '1'; }, 50);
    });
  }, 310);
}

// ===== SCROLL REVEAL =====
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

function propReveal(selector, direction, stagger = false) {
  document.querySelectorAll(selector).forEach((el, i) => {
    el.classList.add('reveal', `reveal--${direction}`);
    if (stagger) el.classList.add(`reveal-delay-${Math.min(i + 1, 6)}`);
    revealObserver.observe(el);
  });
}

propReveal('.spec-item',   'up',    true);
propReveal('.prop-section','fade',  true);
propReveal('.tour-section','up',    false);
propReveal('.sidebar-card',       'right', true);
propReveal('.agent__contact-btn','fade',  true);
propReveal('.feature-item','fade',  true);
propReveal('.map-nearby__tags span', 'fade', true);

// ===== WHATSAPP INTELIGENTE — Sidebar + Float con datos completos de la propiedad =====
function buildPropWaMsg() {
  const title    = document.querySelector('.prop-hero__title')?.textContent?.trim()   || '';
  const location = document.querySelector('.prop-hero__location')?.innerText?.trim()  || '';
  const price    = document.querySelector('.sidebar-price__value')?.textContent?.trim() || '';
  const badge    = document.querySelector('.prop-badge:not(.prop-badge--ref)')?.textContent?.trim() || '';

  const specVals   = Array.from(document.querySelectorAll('.spec-item__value'));
  const specLabels = Array.from(document.querySelectorAll('.spec-item__label'));
  const specs = specVals
    .map((v, i) => `${v.textContent.trim()} ${specLabels[i]?.textContent?.trim() || ''}`.trim())
    .filter(Boolean)
    .join(' · ');

  const url = window.location.href;

  // Si no estamos en página de propiedad, mensaje simple con URL de la página actual
  if (!title) {
    return (
      `¡Hola Juliana! Quisiera más información sobre sus propiedades.\n\n` +
      `🔗 ${url}\n\n` +
      `Gracias.`
    );
  }

  const tipo = badge.toLowerCase().includes('alquiler') ? '🔑 Alquiler' : '🏷️ Venta';

  return (
    `¡Hola Juliana! Vi en MJ Group Real Estate la siguiente propiedad y me interesa:\n\n` +
    `🏠 ${title}\n` +
    `📍 ${location}\n` +
    `💰 ${price} COP\n` +
    (specs ? `📐 ${specs}\n` : '') +
    `${tipo}\n` +
    `🔗 ${url}\n\n` +
    `¿Podrías darme más información?`
  );
}

function attachWaHandler(btn) {
  if (!btn) return;
  const updateHref = () => {
    try {
      btn.href   = `https://wa.me/573218292749?text=${encodeURIComponent(buildPropWaMsg())}`;
      btn.target = '_blank';
      btn.rel    = 'noopener';
    } catch (e) { /* noop */ }
  };
  // Set href inmediatamente al cargar (cubre el caso de tap rápido sin mousedown/touchstart previos)
  updateHref();
  // Red de seguridad: actualiza en cada interacción
  btn.addEventListener('mousedown',  updateHref);
  btn.addEventListener('touchstart', updateHref, { passive: true });
  // Bulletproof: click abre directamente con el mensaje recién armado
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const waUrl = `https://wa.me/573218292749?text=${encodeURIComponent(buildPropWaMsg())}`;
    window.open(waUrl, '_blank', 'noopener');
  });
}

attachWaHandler(document.querySelector('.wa-btn'));
// .wa-float tiene su propio onclick inline en el HTML (bulletproof, sin dependencia de este script)

// Fallback global: el <a class="wa-float"> usa onclick="window.mjOpenWa(event)" como
// red de seguridad inline — independiente de cuándo corra el defer de este script.
window.mjOpenWa = function(e) {
  try {
    if (e && e.preventDefault) e.preventDefault();
    var msg = (typeof buildPropWaMsg === 'function')
      ? buildPropWaMsg()
      : '¡Hola Juliana! Quisiera más información.\n\n🔗 ' + window.location.href;
    var url = 'https://wa.me/573218292749?text=' + encodeURIComponent(msg);
    window.open(url, '_blank', 'noopener');
  } catch (err) {
    window.open('https://wa.me/573218292749', '_blank', 'noopener');
  }
  return false;
};

// WA buttons en propiedades relacionadas
document.querySelectorAll('.prop-card__wa').forEach(btn => {
  const setRelWaHref = () => {
    const card     = btn.closest('.catalog-card');
    if (!card) return;
    const title    = card.querySelector('.catalog-card__title')?.textContent?.trim()  || '';
    const locEl    = card.querySelector('.catalog-card__location');
    const location = locEl ? locEl.innerText?.trim() : '';
    const priceEl  = card.querySelector('.catalog-card__price');
    const price    = priceEl ? priceEl.innerText?.trim() : '';
    const specs    = Array.from(card.querySelectorAll('.spec span')).map(s => s.textContent.trim()).filter(Boolean).join(' · ');
    const cardUrl  = card.dataset.url ? (window.location.origin + card.dataset.url) : window.location.href;

    const msg =
      `¡Hola Juliana! Vi en MJ Group Real Estate una propiedad que me interesa:\n\n` +
      `🏠 ${title}\n📍 ${location}\n💰 ${price}\n📐 ${specs}\n` +
      `🔗 ${cardUrl}\n\n` +
      `¿Podrías darme más información?`;

    btn.href   = `https://wa.me/573218292749?text=${encodeURIComponent(msg)}`;
    btn.target = '_blank';
    btn.rel    = 'noopener';
  };
  btn.addEventListener('mousedown',  setRelWaHref);
  btn.addEventListener('touchstart', setRelWaHref, { passive: true });
});

// ===== RIPPLE EN BOTONES =====
document.querySelectorAll('.btn').forEach(btn => {
  btn.addEventListener('click', (e) => {
    const rect   = btn.getBoundingClientRect();
    const ripple = document.createElement('span');
    ripple.className = 'btn-ripple';
    const size = Math.max(rect.width, rect.height);
    ripple.style.width  = size + 'px';
    ripple.style.height = size + 'px';
    ripple.style.left   = (e.clientX - rect.left - size / 2) + 'px';
    ripple.style.top    = (e.clientY - rect.top  - size / 2) + 'px';
    btn.appendChild(ripple);
    setTimeout(() => ripple.remove(), 700);
  });
});

// ===== EFECTO MAGNÉTICO EN BOTONES =====
document.querySelectorAll('.btn--primary:not(.btn--full), .btn--outline:not(.btn--full)').forEach(btn => {
  btn.addEventListener('mousemove', (e) => {
    const rect = btn.getBoundingClientRect();
    const x    = (e.clientX - rect.left  - rect.width  / 2) * 0.15;
    const y    = (e.clientY - rect.top   - rect.height / 2) * 0.15;
    btn.style.transform = `translate(${x}px, ${y}px) translateY(-2px)`;
  });
  btn.addEventListener('mouseleave', () => {
    btn.style.transform = '';
  });
});
